import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';

import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'www.linkedin.com/in/george-vytka',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },

  {
    link: 'mailto:george.vytka@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
